export const defineCustomPrototypeFunctions = () => {
  String.prototype.toFlatText = function () {
    const camelCase = this.replace(/([a-z])([A-Z])/g, "$1 $2").split(" ");
    let flat = "";

    camelCase.forEach((word, index) => {
      flat =
        flat + word.charAt(0)[index === 0 ? "toUpperCase" : "toLowerCase"]() + word.slice(1) + " ";
    });
    return flat.trim();
  };
  Array.prototype.sortAlphabetical = function (key) {
    return this.sort((a, b) => {
      // ignore upper and lowercase
      const nameA = (key ? a[key] : a)?.toUpperCase();
      const nameB = (key ? b[key] : b)?.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      // names must be equal
      return 0;
    });
  };
};
